<template>
  <div
    class="border-lightSecondaryColor bg-lightSecondaryColor dark:border-darkSecondaryColor dark:bg-darkTertiaryColor border-t px-4 py-3"
  >
    <div class="text-lightSecondaryTextColor dark:text-darkSecondaryTextColor flex items-center justify-between text-xs">
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-1">
          <kbd
            class="border-lightTertiaryColor bg-lightPrimaryColor text-lightPrimaryTextColor dark:border-darkSecondaryColor dark:bg-darkSecondaryColor dark:text-darkPrimaryTextColor inline-flex items-center rounded border px-1.5 py-0.5 font-mono font-medium"
          >
            ↑↓
          </kbd>
          <span>{{ $t("quickAccess.footer.navigate") }}</span>
        </div>
        <div class="flex items-center gap-1">
          <kbd
            class="border-lightTertiaryColor bg-lightPrimaryColor text-lightPrimaryTextColor dark:border-darkSecondaryColor dark:bg-darkSecondaryColor dark:text-darkPrimaryTextColor inline-flex items-center rounded border px-1.5 py-0.5 font-mono font-medium"
          >
            ↵
          </kbd>
          <span>{{ $t("quickAccess.footer.select") }}</span>
        </div>
      </div>
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-1">
          <kbd
            class="border-lightTertiaryColor bg-lightPrimaryColor text-lightPrimaryTextColor dark:border-darkSecondaryColor dark:bg-darkSecondaryColor dark:text-darkPrimaryTextColor inline-flex items-center rounded border px-1.5 py-0.5 font-mono font-medium"
          >
            ESC
          </kbd>
          <span>{{ $t("quickAccess.footer.close") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
